module.exports = __webpack_public_path__ + "static/media/normal-eye-diagram.f86e4581.png";